import _defineProperty from "/app/workspaces/v_1/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { Block } from '../../abstract/Block.js';
export class ProgressBar extends Block {
  constructor() {
    super(...arguments);
    /** @type {Number} */
    _defineProperty(this, "_value", 0);
    _defineProperty(this, "init$", {
      ...this.init$,
      width: 0,
      opacity: 0
    });
  }
  initCallback() {
    super.initCallback();
    this.defineAccessor('value', value => {
      if (value === undefined) {
        return;
      }
      const prevValue = this._value;
      this._value = value;
      if (value === 0 && prevValue > 0) {
        this.ref.line.addEventListener('transitionend', () => {
          this.style.setProperty('--l-width', this._value.toString());
        });
        return;
      }
      this.style.setProperty('--l-width', this._value.toString());
    });
    this.defineAccessor('visible', visible => {
      this.ref.line.classList.toggle('progress--hidden', !visible);
    });
  }
}
ProgressBar.template = /* HTML */" <div ref=\"line\" class=\"progress\"></div> ";